import React from "react";
import { Route, Routes } from "react-router-dom";
import SubNavbar from "./SubNavbar.jsx";
import "./SoftwareUpdate.scss";
import Modules from "./Modules/Modules.jsx";
import Plans from "../SoftwareUpdate/Plans/Plans.jsx";
import Pricing from "./Pricing/Pricing.jsx";
import Discounts from "./Discounts/Discounts.jsx";

function SoftwareUpdate() {
  return (
    <div>
      <SubNavbar />
      <div className="software-update-content">
        <Routes>
          <Route path="modules" element={<Modules />} />
          <Route path="plans" element={<Plans />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="discounts" element={<Discounts />} />
          <Route path="*" element={<Modules />} /> {/* Default route */}
        </Routes>
      </div>
    </div>
  );
}

export default SoftwareUpdate;
